import {
  DialogActions,
  DialogContent,
  DialogTitle,
  Tooltip,
  Typography,
} from '@material-ui/core'
import { Check, ErrorOutline, Person } from '@material-ui/icons'
import { FC } from 'react'

import Button from '@/components/button'

import { useStyles } from './styles'

const submittedStatus = {
  invited: 'invited',
  duplicated: 'duplicated',
  error: 'error',
}

const iconsStatus = {
  invited: (
    <Tooltip title='Convite enviado' placement='right'>
      <Check color='primary' />
    </Tooltip>
  ),
  duplicated: (
    <Tooltip title='E-mail já cadastrado' placement='right'>
      <Person color='disabled' />
    </Tooltip>
  ),
  error: (
    <Tooltip title='Ocorreu um erro ao enviar o email' placement='right'>
      <ErrorOutline color='error' />
    </Tooltip>
  ),
}

type SubmittedContentProps = {
  handleModal: () => void
  invitations: {
    email: string
    name: string
    status: keyof typeof submittedStatus
  }[]
}

const SubmittedContent: FC<SubmittedContentProps> = ({
  handleModal,
  invitations,
}) => {
  const classes = useStyles()

  return (
    <>
      <DialogTitle disableTypography>
        <Typography variant='h2'>Convidar membros</Typography>
        <Typography variant='subtitle1'>
          A lista abaixo mostra o status dos convites solicitados na etapa
          anterior.
        </Typography>
        <Typography variant='subtitle1'>
          Caso tenha ocorrido algum erro com o convite confirme o E-mail
          utilizado e tente novamente mais tarde.
        </Typography>
      </DialogTitle>
      <DialogContent classes={{ root: classes.content }}>
        <ul>
          {invitations.map(({ email, name, status }) => (
            <li
              key={email}
              {...{
                ...(status === submittedStatus.invited && {
                  className: classes.background,
                }),
              }}
            >
              <Typography variant='subtitle1'>{email}</Typography>
              <Typography>
                <b>{name || '-'}</b>
              </Typography>
              {iconsStatus[status]}
            </li>
          ))}
        </ul>
      </DialogContent>
      <DialogActions classes={{ root: classes.actions }}>
        <Button onClick={handleModal}>Ir para página de membros</Button>
      </DialogActions>
    </>
  )
}

export default SubmittedContent
